import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { default as RBPopover } from 'react-bootstrap/Popover';
import { PLACEMENT } from '../../values/Placement';
const PLACEMENT_MAP = {
    AUTO: PLACEMENT.AUTO,
    TOP: PLACEMENT.TOP,
    RIGHT: PLACEMENT.RIGHT,
    BOTTOM: PLACEMENT.BOTTOM,
    LEFT: PLACEMENT.LEFT,
};
const Popover = forwardRef((props, ref) => {
    const { title, titleClassName = '', contentClassName = '', children } = props, remainingProps = __rest(props, ["title", "titleClassName", "contentClassName", "children"]);
    return (_jsxs(RBPopover, Object.assign({ ref: ref }, remainingProps, { children: [title && _jsx(RBPopover.Title, Object.assign({ className: `popover-title ${titleClassName}` }, { children: title })), children && (_jsx(RBPopover.Content, Object.assign({ className: `popover-content ${contentClassName}` }, { children: children })))] })));
});
Object.assign(Popover, PLACEMENT_MAP);
export default Popover;
